import { API } from "../api/API";
import { validateResponseStatus } from "../utils";

export const getValidIBO = async (iboCode) => {
  const result = await API()
    .get(`/lyra/distributor/validateAccess/${iboCode}`)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  return result;
};
